import { createComponent } from '@bigyouth/base'

import './style/styles-occasion.scss'
import * as features from './features/exports/occasion'

Object.values(features).forEach(createComponent)
